import { useEffect } from 'react';
import { X } from 'lucide-react';
import TimelineEntryForm from './TimelineEntryForm';
import type { TimelineEntry } from '../../types/timeline';

interface TimelineEntryPopupProps {
  contactId: string;
  entry?: TimelineEntry;
  onClose: () => void;
  onSuccess: () => void;
}

export default function TimelineEntryPopup({ contactId, entry, onClose, onSuccess }: TimelineEntryPopupProps) {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.stopPropagation();
        onClose();
      }
    };

    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [onClose]);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-dark-800 rounded-lg w-[60%] h-[80%] flex flex-col">
        {/* Header */}
        <div className="flex-none p-6 border-b border-gray-700">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-semibold">
              {entry ? 'Edit Timeline Entry' : 'Add Timeline Entry'}
            </h2>
            <button 
              onClick={onClose}
              className="text-gray-400 hover:text-white"
            >
              <X className="w-6 h-6" />
            </button>
          </div>
        </div>

        {/* Content Area */}
        <div className="flex-grow overflow-y-auto p-6">
          <TimelineEntryForm
            contactId={contactId}
            entry={entry}
            onSuccess={() => {
              onSuccess();
              onClose();
            }}
            onCancel={onClose}
          />
        </div>
      </div>
    </div>
  );
}